module.exports = __webpack_public_path__ + "static/media/icon-moduleE5.a32aedc6.png";